import { z } from 'zod'

/** 解析欲綁定企業會員名單的檔案資料 Response Schema */
export const companyEmployeeAnalyzeEmailSchema = z.object({
  /** 檢核成功的Email */
  successEmail: z.array(z.string()),
  /** 檢核成功的Email筆數 */
  successCount: z.number(),
  /** 檢核失敗的Email */
  failEmail: z.array(z.string()),
  /** 檢核失敗的Email筆數 */
  failCount: z.number()
})

/** 解析欲綁定企業會員名單的檔案資料 Response */
export interface CompanyEmployeeAnalyzeEmail
  extends z.infer<typeof companyEmployeeAnalyzeEmailSchema> {}

export class CompanyEmployeeAnalyzeEmail {
  constructor() {
    return {
      successEmail: [],
      successCount: 0,
      failEmail: [],
      failCount: 0
    }
  }
}
